import React, { useEffect, useLayoutEffect } from "react";

import $ from "jquery";
import ReactPlayer from "react-player";

const imageAspectRatio = 0.5625;

const isScrollable = container => {
  return container.height() < imageAspectRatio * container.width();
};

const scroll = container => {
  container.scrollTop(
    (imageAspectRatio * container.width() - container.height()) / 2
  );
};

export const Player = props => {
  useLayoutEffect(() => {
    // Scroll to middle of image
    const outerContainer = $(".custom-homepage-image");
    if (isScrollable(outerContainer)) {
      scroll(outerContainer);
    }
  }, []);

  useEffect(() => {
    // Scroll to middle of image for first load
    const outerContainer = $(".custom-homepage-image");
    if (isScrollable(outerContainer)) {
      scroll(outerContainer);
    }
  }, []);

  return (
    <div className="wrapper-container">
      <ReactPlayer
        className="custom-react-player"
        width="100%"
        height="100%"
        url={props.url}
        pip={false}
        playing={props.playing}
        controls={false}
        loop={false}
        muted={false}
        onPlay={() => props.setPlaying(true)}
        onEnded={props.handleEnded}
        onError={e => console.log("onError", e)}
      />
      <img src={props.frameImg} alt="Factory" />
      {props.children}
    </div>
  );
};
